// extracted by mini-css-extract-plugin
export default {"form":"ContactInfoUpdateForm__form--1fS","error":"ContactInfoUpdateForm__error--34D","buttons":"ContactInfoUpdateForm__buttons--2iL","button":"ContactInfoUpdateForm__button--3bb"};